import api from '../api';

// Helper to get a default campaign if needed
// For Batch Creation (fashion/lookbook), always use 'lookbook' type campaign
export const ensureCampaign = async (): Promise<number> => {
    try {
        // Filter by type server-side: GET /campaigns is paginated (10/page, newest
        // first), so an unfiltered fetch only sees the 10 most recent campaigns. A
        // user with 10+ newer campaigns of other types would have their lookbook
        // workspace fall off page 1 — the find() below would miss it and the fallback
        // create would then hit the unique (name, user_id) constraint (422 "name taken").
        const campaigns = await api.get('/campaigns', { params: { type: ['lookbook'] } });
        const data = (campaigns.data as any)?.data ?? campaigns.data;
        // Falha alto se a lista vier fora do formato esperado: tratar como "vazio"
        // aqui faria o fluxo CRIAR uma campanha nova (workspace duplicado) a cada
        // resposta torta. Melhor abortar do que duplicar.
        if (!Array.isArray(data)) {
            throw new Error('Resposta inesperada de /campaigns ao garantir campanha');
        }
        // Look for existing 'lookbook' campaign first (for Batch Creation)
        // This ensures we don't accidentally use 'home-decor' or other campaign types
        const lookbookCampaign = data.find((c: any) => c.type === 'lookbook');
        if (lookbookCampaign) {
            console.log(`[ensureCampaign] Using existing lookbook campaign #${lookbookCampaign.id}`);
            return lookbookCampaign.id;
        }
        // If no lookbook campaign exists, create one
        console.log('[ensureCampaign] Creating new lookbook campaign');
        const newCampaign = await api.post('/campaigns', { name: 'General Workspace', type: 'lookbook' });
        return (newCampaign.data as any).data.id;
    } catch (e) {
        console.error("Failed to ensure campaign", e);
        throw e;
    }
};

// Ensure Home Decor Campaign exists
export const ensureHomeDecorCampaign = async (): Promise<number> => {
    try {
        // Same pagination guard as ensureCampaign: filter by type so the home-decor
        // workspace is found regardless of how many other campaigns the user has.
        const campaigns = await api.get('/campaigns', { params: { type: ['home-decor'] } });
        const data = (campaigns.data as any)?.data ?? campaigns.data;
        if (!Array.isArray(data)) {
            throw new Error('Resposta inesperada de /campaigns ao garantir campanha home-decor');
        }
        const homeDecorCampaign = data.find((c: any) => c.type === 'home-decor');

        if (homeDecorCampaign) {
            return homeDecorCampaign.id;
        }

        const newCampaign = await api.post('/campaigns', { name: 'Home & Decor Workspace', type: 'home-decor' });
        return (newCampaign.data as any).data.id;
    } catch (e) {
        console.error("Failed to ensure home-decor campaign", e);
        throw e;
    }
};
